import React from "react";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import FormInput from "../../../common/forms/FormInput";
import LoadingSpinner from "../../../common/LoadingSpinner";
import ActionBtn from "../../../common/management/ActionBtn";
import ListWrapper from "../../../common/management/ListWrapper";
import FeaturedSettingsItem from "./FeaturedSettingsItem";
import NotificationModal from "../../../common/settings-modal/NotificationModal";
import SelenaA from "../../../assets/img/selena-a.webp";
import {
  genNotificationColor,
  genNotificationMessage,
  RequestState,
} from "../../../utils/RequestState";

type Props = {
  target: string;
  name: string;
  id: string;
  contentTitleLabel?: string;
  isLoading: boolean;
  options: Array<string>;
  selectedItems: Array<{ id: string; name: string; status: string }>;
  featuredTitle: string;
  requestState: RequestState;
  addItem: () => void;
  removeItem: (index: number) => void;
  handleChange: (index: number, value: string) => boolean;
  handleTitle: (value: string) => void;
  handleSubmit: () => void;
};
const FeaturedSettings: React.FC<Props> = ({
  target,
  name,
  id,
  contentTitleLabel = "イチオシコンテントタイトル",
  isLoading,
  options,
  selectedItems,
  featuredTitle,
  requestState,
  addItem,
  removeItem,
  handleChange,
  handleTitle,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <ListWrapper pageTitle={`イチオシ${target}設定`}>
      {isLoading ? (
        <LoadingSpinner space={5} admin_page={true} />
      ) : (
        <div className={styles["c-management__box"]}>
          <form>
            <div
              className={`${styles["c-management__input-item"]} ${styles["featured-title"]}`}
            >
              <FormInput
                type="text"
                label={contentTitleLabel}
                name="sonic_title"
                handler={(val: string) => handleTitle(val)}
                initial_value={featuredTitle}
              />
            </div>
            <ul>
              {selectedItems.map((item, i) => {
                return (
                  <FeaturedSettingsItem
                    key={i}
                    index={i}
                    target={target}
                    name={name}
                    id={id}
                    featuredItem={item}
                    options={options}
                    handleChange={handleChange}
                    removeItem={removeItem}
                  />
                );
              })}
            </ul>
            <div className={styles["c-management__flex-wrapper"]}>
              <ActionBtn
                label={t(`${target}を追加`)}
                icon={["fal", "plus-circle"]}
                onClick={() => addItem()}
              />
              <ActionBtn
                label={t("保存して公開")}
                onClick={() => handleSubmit()}
                colorReversal={true}
              />
            </div>
          </form>
          {requestState !== RequestState.Waiting ? (
            <NotificationModal
              color={genNotificationColor(requestState)}
              message={genNotificationMessage(requestState)}
              img_src={
                requestState === RequestState.Success ? SelenaA : undefined
              }
            />
          ) : null}
        </div>
      )}
    </ListWrapper>
  );
};

export default FeaturedSettings;
